/* BI-13 · DOWNGRADE SELECTION (§61)
   Nothing is deleted. Read-only locations keep customers, issued gifts,
   terms and history intact, and issued gifts stay redeemable.
   FQ-I4: a downgrade from several establishments is the multi plan's only (post-launch); elsewhere it is Votre offre. */
import { Navigate } from 'react-router-dom'
import { Button, Checkbox, ListRow, Note } from '@/ui'
import { getPlan } from '@/lib/campaign'
import { Head, useBill } from './ParamShell'

export default function BI13Starter() {
  const rows = useBill().downgrade
  if (getPlan() !== 'multi') return <Navigate replace to="/parametres/offre" />
  return (
    <section data-frame="BI-13" style={{ display: 'grid', gap: 14 }}>
      <Head title="Repasser en Starter — choisir l’établissement conservé" />
      <p className="t-body">
        Starter inclut 1 établissement actif. Choisissez lequel reste actif — les autres passent
        en lecture seule.
      </p>
      <div>
        {rows.map(r => (
          <ListRow key={r.name} title={r.name} meta={r.meta}
            end={<Checkbox checked={r.keep} readOnly aria-label={`Conserver ${r.name}`} />} />
        ))}
      </div>
      <Note tone="candour">
        Rien n’est supprimé : clients, cadeaux émis, conditions et historique restent intacts et
        consultables. Les campagnes des établissements en lecture seule se mettent en pause ; les
        cadeaux déjà émis restent validables. Réactivation à tout moment.
      </Note>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <Button variant="quiet">Annuler</Button>
        <Button variant="primary">Confirmer le changement</Button>
      </div>
    </section>
  )
}
